<template>
    <div>
        <button @click="downloadFile">
            Download PDF
        </button>
    </div>
</template>

<script>
import getMediaUrl from '@/helpers/getMediaUrl';

export default {
    props: {
        value: {
            type: Object,
            required: true
        }
    },

    methods: {
        downloadFile() {
            const url = getMediaUrl(this.value);

            this.$downloadFile(
                url,
                this.value.name,
                ['video', 'pdf', 'audio'].includes(this.value.type)
            );
        }
    }
};
</script>
